import script from "./QueueCategoryActivitiesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueueCategoryActivitiesPage.vue?vue&type=script&setup=true&lang=ts"

import "./QueueCategoryActivitiesPage.vue?vue&type=style&index=0&id=754daaee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-754daaee"]])

export default __exports__